import ApiService from "./shared/ApiService2";

export default {
  getUsuario: async () => ApiService.get("/api/autenticacao/usuario-logado"),

  logout: async () => ApiService.post("/logout")
};
